
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__tachometer","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 13h6v-1H5zm8-8.34A7 7 0 001 9.61 6.88 6.88 0 001.88 13h1.3l1-.55-.42-.73-1.23.71a6.12 6.12 0 01-.68-2.82v-.54l1.47.26.14-.83L2 8.24a6.24 6.24 0 011.69-3l1 1.2.65-.54-1-1.21a6.11 6.11 0 013.24-1.26V5h.84V3.43a6.11 6.11 0 013.29 1.22l-1 1.21.65.54 1-1.2a6.24 6.24 0 011.69 3l-1.48.26.14.83 1.47-.26v.54a6.12 6.12 0 01-.68 2.82l-1.23-.71-.42.73 1 .55h1.3A6.88 6.88 0 0015 9.61a7 7 0 00-2-4.95zM8.25 10a.58.58 0 000-1.15L5.66 6.91l2 2.51a.58.58 0 00.59.58z"}})])
          )
        }
      }
    